import React from "react";
import EmailIcon from "@material-ui/icons/Email";
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import GitHubIcon  from "@material-ui/icons/GitHub";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import Portrait from '../assets/me_portfolio_e.png'
import "../styles/Home.css"
import { PublicationList } from '../helpers/PublicationList'
import { Link } from "react-router-dom"


//<PictureAsPdfIcon style={{ cursor: 'pointer' }} onClick={event => window.location.href='https://github.com/MJDoyle'} />

function Home() {

    return (
        <div className="home">
            <div className="about">
                <img src={Portrait} alt="MJDoyle" width="169" height="184"/>
                <h2>Dr. Matthew J. Doyle</h2>
                <div className="prompt">
                    <p>Robotics researcher</p>
                    <Link to="https://www.linkedin.com/in/matthew-j-doyle" target="_blank"><LinkedInIcon/></Link>
                    <EmailIcon style={{ cursor: 'pointer' }} onClick={event => window.location.href='mailto:drmatthewjdoyle@gmail.com'} />
                    <Link to="https://github.com/MJDoyle" target="_blank"><GitHubIcon/></Link>
                </div>
            </div>
            <div className="skills">


                <h1>Skills</h1>
                <ol className="list">
                    <li className="item">
                        <h2> Robotics</h2>
                        <span>Embedded systems (Microchip, Arduino), OpenCV, e-puck robots</span>
                    </li>
                    <li className="item">
                        <h2> Coding</h2>
                        <span>C, C++, C#, Python, Unity, Git, Docker, Jenkins</span>
                    </li>
                    <li className="item">
                        <h2> Miscellaneous</h2>
                        <span>3D physics simulation (Open Dynamics Engine), 2D physics simulation (Box2D), Autodesk Fusion 360, KiCad, electronics, soldering, 3D printing, Inkscape, Sketchup, Latex</span>
                    </li>
                </ol>

                <h1>Research Interests</h1>
                <span>Modular robotics, swarm robotics, aquatic robotics, microgravity robotics, artificial ecosystems</span>


                <h1>Publications</h1>
                <ol className="list">
                {PublicationList.map((publication, index) => {
                    return (
                        <li className="item">
                            <p>{publication.title}<i>{publication.location}</i>{publication.date}</p>
                            <Link to={publication.link} target="_blank"><PictureAsPdfIcon/></Link>
                        </li>
                    );
                })}
                </ol>

            </div>
        </div>
    );
}

export default Home;